import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6c9e1afc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=6c9e1afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9e1afc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c9e1afc')) {
      api.createRecord('6c9e1afc', component.options)
    } else {
      api.reload('6c9e1afc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6c9e1afc&scoped=true&", function () {
      api.rerender('6c9e1afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-484pp4dbPaoN5/JS/comp/SearchFilterTokens.vue"
export default component.exports